import React from "react";
import { Tiny } from "@ant-design/plots/es/components";

const ProgressChartMini = (props: any) => {

    const percentText =
        props.percent > 0
            ? `${props.percent.toFixed(1).replace(/\.0$/, "")}%`
            : "0%";
    const percent = Math.max(0, Math.min(1, Number(props.percent || 0) / 100));
    const config = {
        percent,
        width: 80,
        height: 80,
        color: ['#000000', '#FFA800'],
        annotations: [
            {
                type: 'text',
                style: {
                    text: percentText,
                    x: '50%',
                    y: '50%',
                    textAlign: 'center',
                    fontSize: 16,
                    lineHeight: 24,
                    fontStyle: 'normal',
                    fill: "#FFFFFF",
                },
            },
        ],
    };

    return <Tiny.Ring {...config} />;
};

export default ProgressChartMini